import { createFileRoute } from "@tanstack/react-router";

import PrivacyPolicy from "@/components/pages/PrivacyPolicy";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/privacy-policy")({
  component: () => (
    <BasicLayout>
      <PrivacyPolicy />
    </BasicLayout>
  ),
});
